import React, { useState, useEffect } from 'react'
import { Outlet, Link, useLocation } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import './Layout.css'

const Layout: React.FC = () => {
  const { user, logout } = useAuth()
  const location = useLocation()
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)

  // Close mobile menu when route changes
  useEffect(() => {
    setIsMobileMenuOpen(false)
  }, [location.pathname])

  const navigationLinks = [
    { path: '/', label: 'ホーム' },
    { path: '/review', label: '復習' },
    { path: '/learning', label: '学習' },
    { path: '/decks', label: 'デッキ' },
    { path: '/vocabulary', label: '単語' },
    { path: '/bccwj', label: 'BCCWJ' },
    { path: '/triage', label: 'トリアージ' },
    { path: '/progress', label: '進捗' },
  ]

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen)
  }

  return (
    <div className="layout">
      <header className="header">
        <div className="header-content">
          <h1 className="logo">
            <Link to="/">Mana</Link>
          </h1>

          {/* Hamburger menu button (mobile only) */}
          <button
            className={`hamburger ${isMobileMenuOpen ? 'open' : ''}`}
            onClick={toggleMobileMenu}
            aria-label="メニューを開閉"
            aria-expanded={isMobileMenuOpen}
          >
            <span></span>
            <span></span>
            <span></span>
          </button>

          {/* Navigation (desktop: horizontal, mobile: dropdown) */}
          <nav className={`nav ${isMobileMenuOpen ? 'nav-open' : ''}`}>
            {navigationLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`nav-link ${location.pathname === link.path ? 'active' : ''}`}
                onClick={() => setIsMobileMenuOpen(false)}
              >
                {link.label}
              </Link>
            ))}
          </nav>

          <div className="user-info">
            {user ? (
              <>
                <span className="user-name">{user.username}</span>
                <button onClick={logout} className="logout-btn">
                  ログアウト
                </button>
              </>
            ) : (
              <Link to="/login" className="login-btn" onClick={() => setIsMobileMenuOpen(false)}>
                ログイン
              </Link>
            )}
          </div>
        </div>
      </header>

      {/* Overlay for mobile menu */}
      {isMobileMenuOpen && (
        <div className="mobile-overlay" onClick={() => setIsMobileMenuOpen(false)}></div>
      )}

      <main className="main-content">
        <Outlet />
      </main>

      <footer className="footer">
        <p>© 2026 Mana 日本語学習アプリ. All rights reserved.</p>
      </footer>
    </div>
  )
}

export default Layout